import Pending from '@app/action/pending';
import Notification from '@app/action/notification';

import ActionHelper from '@module/redux-actions';
import API from '@app/api';

export const actions = ActionHelper.types([
  'GET_CONTACTS_SUCCESS',
  'REMOVE_CONTACTS_SUCCESS',
  'ADD_CONTACT_SUCCESS',
  'EDIT_CONTACT_SUCCESS',
]);

export default ActionHelper.generate({
  list() {
    const pendingId = 'retrieveContactList';
    return async (dispatch, getState) => {
      if (!getState().contacts.list) {
        dispatch(Pending.setPending(pendingId));
      }

      try {
        const response = await API.User.getContacts();

        dispatch({
          type: actions.GET_CONTACTS_SUCCESS,
          list: response.body || [],
        });
      } catch (error) {
        if (error.body && error.body.error) {
          dispatch(Notification.setNotification('error', error.body.error));
        } else {
          dispatch(
            Notification.setNotification(
              'error',
              'retrieve_contactlist_exception'
            )
          );
        }
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },

  addContact(params = {}) {
    const pendingId = 'addContact';
    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      try {
        const response = await API.User.addContact(params);

        dispatch({
          type: actions.ADD_CONTACT_SUCCESS,
          contact: response.body,
        });

        dispatch(
          Notification.setNotification('notification', 'add_contact_success')
        );
      } catch (error) {
        if (error.body && error.body.error) {
          dispatch(Notification.setNotification('error', error.body.error));
        } else {
          dispatch(
            Notification.setNotification('error', 'add_contact_exception')
          );
        }
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },

  editContact(id, params = {}) {
    const pendingId = 'editContact';
    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      try {
        const response = await API.User.editContact(params, {
          pathExtValues: {
            contactId: id,
          },
        });

        dispatch({
          type: actions.EDIT_CONTACT_SUCCESS,
          contact: response.body,
        });

        dispatch(
          Notification.setNotification('notification', 'edit_contact_success')
        );
      } catch (error) {
        if (error.body && error.body.error) {
          dispatch(Notification.setNotification('error', error.body.error));
        } else {
          dispatch(
            Notification.setNotification('error', 'edit_contact_exception')
          );
        }
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },

  removeContact(ids = []) {
    const pendingId = 'removeContact';
    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      try {
        await API.User.removeContact({ contact_ids: ids });

        dispatch({
          type: actions.REMOVE_CONTACTS_SUCCESS,
          ids,
        });

        dispatch(
          Notification.setNotification('notification', 'remove_contact_success')
        );
      } catch (error) {
        if (error.body && error.body.error) {
          dispatch(Notification.setNotification('error', error.body.error));
        } else {
          dispatch(
            Notification.setNotification('error', 'remove_contact_exception')
          );
        }
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },
});
